import React, { Component } from "react";
import { connect } from "react-redux";

import MediaFetchingComponent from "./MediaFetchingComponent";

export class MediaFetching extends Component {
  render() {
    return <MediaFetchingComponent />;
  }
}

// Connected Component
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MediaFetching);



// WEBPACK FOOTER //
// ./src/components/Common/MediaFetching/index.js